import { render, staticRenderFns } from "./CommissionTiersCollector.vue?vue&type=template&id=483b145b"
import script from "./CommissionTiersCollector.vue?vue&type=script&lang=js"
export * from "./CommissionTiersCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports